import axios from "axios";
import Links from "../constants/Links";

/**
 * Programme UTME API hook for managing UTME cut-off points
 */

const ProgrammeUtme = {
    /**
     * Update or create UTME requirements for a programme
     * @param {object} data - Contains programmeId and requiredPoint
     * @returns {Promise<object>}
     */
    updateRequiredPoint: async (data) => {
        return axios.post(Links.programmeUtme.update, data);
    },

    /**
     * Get UTME requirements for a specific programme
     * @param {number} programmeId - Programme ID
     * @returns {Promise<object>}
     */
    getRequiredPoint: async (programmeId) => {
        return axios.get(Links.programmeUtme.get, {
            params: { programme: programmeId }
        });
    }
};

export default ProgrammeUtme;